<template>
  <div class="seo-content-detail" v-if="detail.content">
    <h1 class="title">{{ detail.title }}</h1>
    <div class="content" v-html="detail.content"></div>
  </div>
</template>
<script>
export default {
  name: 'BlogDetail',
  props: {},
  data() {
    return {
      detail: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getDetail() {
      const res = await fetch(
        `https://strapi.nicee.tw/api/posts?filters[title]=${this.$route.params.title}`
      );
      const { data } = await res.json();
      if (data && data.length && data[0].attributes) {
        this.detail = data[0].attributes;
      }
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.seo-content-detail {
  margin-bottom: 40px;
  color: #808080;
  font-size: 18px;
  > .title {
    font-size: 23px;
    color: #222222;
    font-weight: 700;
  }
  > .content {
    margin-top: 20px;
    line-height: 31px;
  }
}
</style>
